// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"294":"ccb363b0","346":"b9fcf735"}[chunkId] + ".chunk.css";
};